import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import configureStore from './configureStore'
import 'bootstrap/dist/css/bootstrap.min.css';
function start(): void {

    const initialState = window.INITIAL_REDUX_STATE
    const store = configureStore(initialState)

    ReactDOM.render(
        <App store={store} />
        , document.getElementById('root'));



}
start();